import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ui-datetime-skeleton',
  styleUrls: ['./ui-datetime-skeleton.component.scss'],
  template: `
    <ng-container *ngIf="isLoading; else contentTpl">
      <div class="row">
        <div class="col-6 col-lg-4">
          <div class="ui-datetime-skeleton-label"></div>
          <div class="ui-datetime-skeleton-field"></div>
        </div>

        <div class="col-6 col-lg-4">
          <div class="ui-datetime-skeleton-label"></div>
          <div class="ui-datetime-skeleton-field"></div>
        </div>
      </div>
    </ng-container>

    <ng-template #contentTpl>
      <ng-content></ng-content>
    </ng-template>

  `
})
export class UiDatetimeSkeletonComponent {
  @Input()
  set loading(value: Promise<any>) {
    this._trackPromise(value);
  }

  isLoading = false;
  private _token = 0;

  private _trackPromise(promise: Promise<any> | null | undefined) {
    this._token += 1;
    const token = this._token;

    if (!promise) {
      this.isLoading = false;
      return;
    }

    this.isLoading = true;

    Promise.resolve(promise).finally(() => {
      if (token === this._token) {
        this.isLoading = false;
      }
    });
  }
}
